import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';
import { SeuFormGroupCalculation } from '@seu-types';
import { isNil, uniq } from 'lodash-es';

export function duplicateCombinationValidator(
  abstractForm: AbstractControl
): ValidationErrors | null {
  const formArray = abstractForm as FormArray<SeuFormGroupCalculation>;

  const combinedValuesSet: Record<string, string[]> = {};

  // go through all groups and check if there are any duplicates
  formArray.controls.forEach((formGroup) => {
    const globalSettingsVal = formGroup.value.globalSettings;
    const interconnectionVersionVal = formGroup.value.interconnectionVersion;
    const operatingConditionIds = formGroup.value.operatingConditions;

    if (
      !isNil(globalSettingsVal) &&
      !isNil(interconnectionVersionVal) &&
      !isNil(operatingConditionIds)
    ) {
      const combinedValues = `${globalSettingsVal}_${interconnectionVersionVal}`;

      const isKeyDuplicate =
        combinedValuesSet.hasOwnProperty(combinedValues) &&
        operatingConditionIds.length > 0;

      let isDuplicate = isKeyDuplicate;

      if (isKeyDuplicate) {
        const existingOperatingConditionIds = combinedValuesSet[combinedValues];
        // if any id is the same, then it's a duplicate

        isDuplicate = operatingConditionIds.some((id: string) =>
          existingOperatingConditionIds.includes(id)
        );

        if (!isDuplicate) {
          combinedValuesSet[combinedValues] = uniq([
            ...existingOperatingConditionIds,
            ...operatingConditionIds,
          ]);
        }
      } else {
        combinedValuesSet[combinedValues] = operatingConditionIds;
      }

      formGroup.setErrors(isDuplicate ? { 'duplicate-input': true } : null);
    }

    formGroup.controls.globalSettings.setErrors(
      isNil(globalSettingsVal)
        ? {
            required: true,
          }
        : null
    );

    formGroup.controls.interconnectionVersion.setErrors(
      isNil(interconnectionVersionVal)
        ? {
            required: true,
          }
        : null
    );
  });

  return null;
}
